<template>
  <div>
    <b-modal
      id="careerModal"
      size="md"
      hide-header
      hide-footer
      content-class="custom-modal-content"
      centered
      ref="baseModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @hidden="$emit('hidden')"
    >
      <div
        class="d-flex flex-column align-items-center justify-content-center h-100"
      >
        <p class="modal-title text-center mb-4" v-html="modalText"></p>
        <button
          :style="buttonStyle"
          :class="['btn', 'custom-btn', { 'custom-btn--full': buttonFullWidth }]"
          @click="$emit('button-click')"
        >
          {{ buttonText }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "BaseModal",
  props: {
    modalId: {
      type: String,
      required: true,
    },
    modalText: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonFullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonStyle() {
      const base = {
        backgroundColor: '#009D9E',
        borderRadius: '2px',
        color: '#fff',
        border: 'none',
        padding: '10px',
      };
      if (this.buttonFullWidth) {
        return { ...base, fontSize: '16px' };
      }
      return base;
    },
  },
  methods: {
    show() {
      this.$refs.baseModal.show();
    },
    hide() {
      this.$refs.baseModal.hide();
    },
  },
};
</script>

<style scoped>
.custom-btn {
  margin-top: 45px;
  width: 150px;
  height: 60px;
  font-weight: bold;
  font-size: 27px;
}

.custom-btn--full {
  width: 100%;
}
>>> .custom-modal-content {
  height: 330px !important;
  width: 357px !important;
  margin: auto;
}

>>> .modal-content {
  height: 100%;
}

>>> .modal-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.modal-title {
  font-size: 16px;
  line-height: 2;
  font-weight: bold;
}
</style>
